class LocalStorage {
  get = (key: string) => {
    const value = localStorage.getItem(key);

    try {
      return JSON.parse(value || '');
    } catch (error) {
      return value;
    }
  };

  batchGet = (keys: string[]) =>
    keys.reduce((store: Record<string, any>, currentKey) => {
      const cloneStore = store;
      const value = this.get(currentKey);

      if (value !== null && value !== undefined) {
        cloneStore[currentKey] = value;
      }

      return cloneStore;
    }, {});

  set = ({ key, value }: { key: string; value: Record<string, any> }) => {
    if (!value) {
      this.remove(key);

      return;
    }
    localStorage.setItem(key, JSON.stringify(value));
  };

  remove = (key: string) => {
    localStorage.removeItem(key);
  };

  clear = () => {
    localStorage.clear();
  };
}

export default new LocalStorage();
